/**
 * Funkcija za kreiranje markera za google mapu.
 *
 * @param {object} google Google API
 * @param {object} googleMarkerOptions Google Maps opcije @see https://developers.google.com/maps/documentation/javascript/reference/marker
 * @param {object} customMarkerOptions Naše custom opcije
 * @param {function} clickHandler Funkcija koja se poziva klikom na marker
 */
export default function createMarker(google, googleMarkerOptions, customMarkerOptions, clickHandler) {
    const marker = new google.maps.Marker(googleMarkerOptions);

    // z index variramo za svaki marker jer se inače tekstovi preklapajućih markera ispišu jedni preko drugih
    createMarker.zIndex = createMarker.zIndex ? (createMarker.zIndex + 1) : 50;
    if (createMarker.zIndex >= 200) {
        createMarker.zIndex = 30;
    }
    marker.setZIndex(createMarker.zIndex);

    const { iconData, activeIconData, markerBounceType } = customMarkerOptions;
    let originalMarkerZIndex = marker.getZIndex();
    let strongHighlight = false;
    let isHighlighted = false;

    function highlight() {
        isHighlighted = true;
        marker.setIcon(activeIconData);
        if (marker.getZIndex() !== google.maps.Marker.MAX_ZINDEX) {
            originalMarkerZIndex = marker.getZIndex();
        }
        marker.setZIndex(google.maps.Marker.MAX_ZINDEX);
    }

    function removeHighlight() {
        isHighlighted = false;
        marker.setIcon(iconData);
        marker.setZIndex(originalMarkerZIndex);
    }

    function toggleHighlight() {
        if (isHighlighted) {
            removeHighlight();
        } else {
            highlight();
        }
    }

    marker.highlight = () => {
        strongHighlight = true;
        highlight();
    };

    marker.removeHighlight = () => {
        strongHighlight = false;
        removeHighlight();
    };

    marker.bounceXTimes = (timesToBounce) => {
        if (markerBounceType === 'flash') {
            const maxLoops = timesToBounce === 1 ? 1 : timesToBounce + 1;
            for (let i = 0; i <= maxLoops; i += 2) {
                setTimeout(toggleHighlight, 350 * i);
                setTimeout(toggleHighlight, 350 * (i + 1));
            }
        } else {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => {
                marker.setAnimation(null);
            }, timesToBounce * 700);
        }
    };

    marker.addListener('mouseover', () => {
        highlight();
    });

    marker.addListener('mouseout', function removeHighlightIfPossible() {
        if (strongHighlight) {
            return;
        }

        this.removeHighlight();
    });

    if (typeof clickHandler === 'function') {
        marker.addListener('click', function handleMarkerClick() {
            clickHandler(this);
        });
    }

    return marker;
}
